<template>
  <div>
    <SOSlotBase
        :bg-grey="true"
        :container-name="'list-snapConsole-content'"
    >
      <template v-slot:title-bar>
        <SOTitleBar page-title="Daftar Smart Console" type="back" @back="back"/>
      </template>
      <template v-slot:skeleton>
        <div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
          <SOCardSnapConsoleSekleton/>
        </div>
      </template>
      <template v-slot:content>
        <div class="p-x-20 p-t-16 w-limit" v-if="listSnapConsole.data.length > 0 && !pageSetting.loading.list">
          <SOHeaderList
              :title="'Total '+ formatRupiah(listSnapConsole.jumlah_console) +' Smart Console'"
              :show-filter="true"
              @filter="() => {pageSetting.showFilter = true}"
          />
          <SOCardSnapConsole
              v-for="console in listSnapConsole.data"
              :id-console="console.id"
              :machine-count="console.snap_console_mesin.length"
              :jenis="console.jenis"
              :tanggal="console.created_at"

              :more-menu-id="pageSetting.modal.moreMenuId"

              @openMoreMenu="moreMenuAction(console.id)"
              @onPinConsole="actionModalPin(console.pin, console.id)"
              @onLihatMesin="toListMesin(console.id)"
          />
        </div>

        <SOLoadMoreLoading :id="'loading-list-snapConsole'" :loading="pageSetting.loading.loadMore"/>
      </template>
      <template v-slot:empty-state>
        <SOEmptyState
            v-if="listSnapConsole.data.length === 0 && !pageSetting.loading.list"
            message="Outlet belum memasang Smart Console"
            sub-message="Pasang Smart Console untuk mempermudah pembayaran QRIS Outletmu."
        />
      </template>
      <template v-slot:filter>
        <SOFilter
            v-if="pageSetting.showFilter"
            @back="() => { pageSetting.showFilter = false }"
            :filter-jenis-snap-console="pageSetting.showFilter"
            :sorting="sorting"
            @do-filter="doFilter"
        />
      </template>
      <template v-slot:modal>
        <SnapConsoleModalPin
            v-if="pageSetting.modal.pin"
            :pin-console="pageSetting.modal.pin"
            :id-console="idconsole"

            @close="() => {this.pageSetting.modal.pin = false}"
            @onUpdateSuccess="updateSuccess"
        />
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFilter from "@/so-components/global/filter/base/SOFilter";

import SnapConsoleModalPin from "./modal/SnapConsoleModalPin";
import SOCardSnapConsole from "./component/SOCardSnapConsole";
import SOCardSnapConsoleSekleton from "./component/SOCardSnapConsoleSekleton";

export default {
  name: "SnapConsole",
  components: {
    SOFilter,
    SOLoadMoreLoading,
    SnapConsoleModalPin,
    SOSlotModal,
    SOCardSnapConsoleSekleton,
    SOCardSnapConsole,
    SOHeaderList,
    SOEmptyState,
    SOTitleBar,
    SOSlotBase
  },
  data() {
    return {
      pageSetting: {
        showFilter: false,

        loading: {
          list: true,
          loadMore: false,
        },
        modal: {
          pin: false,
          moreMenuId: false
        },
        error: {
          list: false,
        }
      },
      idconsole: ""
    }
  },
  methods: {
    back() {
      this.$router.push("/addOutlet/"+this.$route.query.idoutlet)
    },
    actionModalPin(pin, idconsole) {
      if (!this.pageSetting.modal.pin) {
        this.pageSetting.modal.pin = pin
        this.idconsole = idconsole
      } else {
        this.pageSetting.modal.pin = false
        this.idconsole = ""
      }
    },

    toListMesin(idconsole) {
      this.$router.push({
        name: "ListSnapMesin",
        query: {
          idoutlet: this.$route.params.idoutlet,
          idconsole: idconsole
        }
      })
    },

    async getDataListSnapConsole() {
      if (!this.pageSetting.loading.list) {
        this.pageSetting.loading.loadMore = true
      }
      const res = await this.$store.dispatch("snapConsoleModule/fetchListSnapConsole", this.$route.params.idoutlet)
      this.pageSetting.loading.list = false
      this.pageSetting.loading.loadMore = false
      await this.$store.commit("helper/setScrollCalled", false)
      if (res.success) {
        this.pageSetting.error.list = false
        await this.$store.commit("snapConsoleModule/setNextPagination", {data: this.listSnapConsole.data})
      } else {
        this.pageSetting.error.list = true
        setTimeout(() => {
          this.pageSetting.error.list = false
        }, 10000)
        this.$toast.error(res.err)
      }
    },

    scroll() {
      window.onscroll = async () => {
        if (this.pageSetting.error.list) {
          return
        }
        let payload = {
          idLoadMore: "loading-list-snapConsole",
          container: "list-snapConsole-content",
          pagination: this.pagination,
          callback: this.getDataListSnapConsole,
        }
        await this.$store.dispatch("helper/scroll", payload)
      }
    },

    async updateSuccess(params) {
      this.pageSetting.modal.pin = false
      await this.$store.commit("snapConsoleModule/resetListSnapConsole")
      await this.$toast.success(params.msg)
      window.location.reload()
    },

    moreMenuAction(id) {
      if (this.pageSetting.modal.moreMenuId) {
        this.pageSetting.modal.moreMenuId = false
      } else {
        this.pageSetting.modal.moreMenuId = id
      }
    },

    async doFilter() {
      this.pageSetting.loading.list = true
      await this.$store.commit("snapConsoleModule/resetPagination")
      await this.$store.commit("snapConsoleModule/resetListSnapConsole")
      this.pageSetting.showFilter = false
      await this.getDataListSnapConsole()
      this.pageSetting.loading.list = false
    }
  },
  async mounted() {
    await this.getDataListSnapConsole()
    await this.scroll()
  },
  async beforeDestroy() {
    await this.$store.commit("snapConsoleModule/resetListSnapConsole")
    await this.$store.commit("snapConsoleModule/resetPagination")
  },
  computed: {
    ...mapGetters("snapConsoleModule", {
      listSnapConsole: "getListSnapConsole",
      pagination: "getPagination"
    })
  }
}
</script>

<style scoped>

</style>